/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * train-with-me
 * OpenAPI spec version: 1.0
 */

export type TrainWithMeModulesSubscriptionsProcessorsWebCheckoutOutcome = typeof TrainWithMeModulesSubscriptionsProcessorsWebCheckoutOutcome[keyof typeof TrainWithMeModulesSubscriptionsProcessorsWebCheckoutOutcome];


export const TrainWithMeModulesSubscriptionsProcessorsWebCheckoutOutcome = {
  Entitled: 'Entitled',
  Activating: 'Activating',
  NothingPurchased: 'NothingPurchased',
} as const;
